import React, { useState, useEffect } from 'react';
import ListComment from '../../../components/Admin/Comment/ListComment';
import { getCommentsByPostsApi, restoreDataPostApi, getCommentsStatsApi } from '../../../api/comment';
import { getAccessTokenApi } from '../../../api/auth';
import ShowComment from '../../../components/Admin/Comment/ShowComment';
import Modal from '../../../components/Modal';
import Swal from 'sweetalert2';
import { errorModal, successModal } from '../../../components/Alerts/Alerts';


export default function Comment(props) {
    const [ comments, setComments ] = useState([]);
    const [ commentsStats, setCommentsStats ] = useState([]);
    const [ reloadComment, setReloadComment ] = useState(false);
    const [ isVisibleModal, setIsVisibleModal ] = useState(false);
    const [ modalTitle, setModalTitle ] = useState("");
    const [ modalContent, setModalContent ] = useState(null);

    useEffect(() => {
        let token = getAccessTokenApi();
        getCommentsByPostsApi(token).then(response => {
            setComments(response.posts);
        });

        getCommentsStatsApi(token).then(response => {
            setCommentsStats(response.stats);
        });

        setReloadComment(false);
    }, [reloadComment]);

    const showComment = comments => {
        setIsVisibleModal(true);
        setModalTitle(`Comentarios: ${comments.nm_titulo}`);
        setModalContent(
                <ShowComment
                    comments={comments}
                    setIsVisibleModal={setIsVisibleModal}
                />
            );
    }

    const showDeleteConfirm = comments => {
        const accessToken = getAccessTokenApi();

        Swal.fire({
            title: 'Restablecer publicación',
            text: "¿Está seguro que desea eliminar las votaciones, visitas y comentarios de esta publicación?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Restablecer'
          }).then((result) => {
            if (result.value) {
                restoreDataPostApi(accessToken, comments._id)
                .then(response => {
                    
                    if(response.code === 200){

                        let pages = localStorage.getItem('page');
                        if (pages) {
                            let result = pages.replace(comments.url, '');
                            localStorage.setItem('page', result);
                        }
                        
                        successModal("","Se restableció la publicación satisfactoriamente.");
                        setReloadComment(true);
                    }
                })
                .catch(err => {
                    errorModal	("Error", err);
                })
            }
    })}

    return (
        <div>
            <ListComment 
                comments={comments} 
                setReloadComment={setReloadComment} 
                showComment={showComment}
                showDeleteConfirm={showDeleteConfirm}
                commentsStats={commentsStats}
            />

            <Modal
                    title={modalTitle}
                    isVisible={isVisibleModal}
                    setIsVisible={setIsVisibleModal}
                    setSize='xl'
                >
                    {modalContent}
                </Modal>
        </div>
    )
}